module.exports = __webpack_public_path__ + "static/media/no_image.189080f8.png";